import moment from 'moment';

import { TimeSlotsType } from '@features/tables/schemas/TablesAvailability.schema';

import { isOverlapping } from './isTimeslotOverlapping';

type GuestExperience = { bookings?: unknown[] } | null | undefined;

export function getBookingsForDay(experiences: unknown, dayNumber: number) {
  if (!Array.isArray(experiences)) {
    return [];
  }

  return (experiences as GuestExperience[])
    .filter((experience) => Array.isArray(experience?.bookings))
    .flatMap((experience) => experience?.bookings ?? [])
    .filter((booking: any) => booking && booking.dayNumber === dayNumber);
}

export function filterTimeslotsByExperiences(
  timeSlots: TimeSlotsType,
  {
    experiences,
    visitDate,
    dayNumber,
    delayAfter = 0,
  }: {
    experiences: unknown;
    visitDate?: string;
    dayNumber: number;
    delayAfter?: number;
  }
): TimeSlotsType {
  const bookings = getBookingsForDay(experiences, dayNumber);

  if (!bookings.length || !visitDate) {
    return timeSlots;
  }

  return timeSlots.filter(
    (timeSlot) =>
      !bookings.some((booking: any) =>
        isOverlapping(
          {
            visitDate,
            startTime: moment(timeSlot.timeSlot).format('HH:mm'),
            endTime: moment(timeSlot.timeSlot).format('HH:mm'),
            delayAfter,
            dayNumber,
          },
          booking
        )
      )
  );
}
